<app-page-content [enableMenuButton]="true">
  <span pagetitle>Sendinger med avvik</span>

  <div pagecontent>
    <app-shipment-list *ngIf="!coreConfiguration.isMobile" [headersVisible]="false" [showStatusColumn]="true" [showDeviationColumn]="true" [shipments]="shipments" (sortChanged)="sortChanged($event)"></app-shipment-list>

    <app-list *ngIf="coreConfiguration.isMobile">
      <app-shipment-item *ngFor="let item of shipments" [shipment]="item" (click)="showShipment(item)"></app-shipment-item>
    </app-list>
  </div>

  <div style="display: flex; flex-direction: row-reverse" pagefooter>
    <app-paginator [totalCount]=totalShipmentCount
                   [pageSize]=currentPageSize
                   [enablePageSizeSelector]="!coreConfiguration.isMobile"
                   [pageSizeOptions]="[20, 50, 100, 200]"
                   [pageIndex]=currentPage
                   (page)="changePage($event)">
    </app-paginator>
  </div>
</app-page-content>
